import React from 'react';
import AvisoDePrivacidad from '../components/privacy/AvisoDePrivacidad';

const AvisoDePrivacidadPage: React.FC = () => {
  return <AvisoDePrivacidad />;
};

export default AvisoDePrivacidadPage;
